// @ts-nocheck
import { memo, FC } from "react";
import EllipsisHTML from "react-lines-ellipsis/lib/html";
import ResponsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";

export interface TruncateProps {
  maxLines?: number;
  ellipsis?: string;
  content: string;
}

const ResponsiveHtmlTruncate = ResponsiveHOC()(EllipsisHTML);

const Truncate: FC<TruncateProps> = ({
  maxLines = 3,
  content,
  ellipsis = "&hellip;",
}) => (
  <ResponsiveHtmlTruncate
    unsafeHTML={content}
    maxLine={maxLines}
    ellipsisHTML={ellipsis}
    basedOn="words"
  />
);

export default memo(Truncate);
